import { render } from "./ParagraphCustom.vue?vue&type=template&id=3f649d91&scoped=true"
import script from "./ParagraphCustom.vue?vue&type=script&lang=js"
export * from "./ParagraphCustom.vue?vue&type=script&lang=js"

import "./ParagraphCustom.vue?vue&type=style&index=0&id=3f649d91&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f649d91"]])

export default __exports__